// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Sidebar_logoContainer__3nKNd","sidebar":"Sidebar_sidebar__bkIqC"};